import { MetricTypes } from '@spotify-internal/semantic-metrics';
import { defaultTags, MetricActions, sendMetric } from './utils/metricsHelper';
import getOAuthServerMetadata from './config/getOAuthServerMetadata';

var interactiveLogout = function interactiveLogout(authServerConfig, redirectUri) {
  sendMetric({
    metric_type: MetricTypes.COUNTER,
    what: MetricActions.INTERACTIVE_LOGOUT,
    value: 1,
    tags: Object.assign({
      serverUrl: authServerConfig.url
    }, defaultTags)
  });

  var _getOAuthServerMetada = getOAuthServerMetadata(authServerConfig),
      issuer = _getOAuthServerMetada.issuer;

  var continueUrl = redirectUri || window.location.href;
  window.location.href = "".concat(issuer, "/logout?continue=").concat(encodeURIComponent(continueUrl));
};

export { interactiveLogout };